import request from '@/utils/request'
import { getCommunityId } from '@/api/community/communityApi'

/** 搜索可选人员 */
export function searchFacePersons(params) {
  return request({
    url: '/isup.searchFacePersons',
    method: 'get',
    params: { ...params, communityId: getCommunityId() }
  }).then(response => {
    const res = response.data
    if (res.code !== 0) throw new Error(res.msg || '查询人员失败')
    return res.data
  })
}

/** 保存/替换人脸 */
export function savePersonFace(data) {
  return request({
    url: '/isup.savePersonFace',
    method: 'post',
    data: { ...data, communityId: getCommunityId() }
  }).then(response => {
    const res = response.data
    if (res.code !== 0) throw new Error(res.msg || '保存人脸失败')
    return res.data
  })
}

/** 删除/撤销人脸 */
export function deletePersonFace(data) {
  return request({
    url: '/isup.deletePersonFace',
    method: 'post',
    data: { ...data, communityId: getCommunityId() }
  }).then(response => {
    const res = response.data
    if (res.code !== 0) throw new Error(res.msg || '撤销人脸失败')
    return res.data
  })
}

/** 人员人脸列表 */
export function listPersonFaces(params) {
  return request({
    url: '/isup.listPersonFaces',
    method: 'get',
    params: { ...params, communityId: getCommunityId() }
  }).then(response => {
    return response.data
  })
}

/** 每台门禁同步详情 */
export function listPersonDeviceSyncs(params) {
  return request({
    url: '/isup.listPersonDeviceSyncs',
    method: 'get',
    params: { ...params, communityId: getCommunityId() }
  }).then(response => {
    return response.data
  })
}

/** 单条重试 */
export function retryPersonDeviceSync(data) {
  return request({
    url: '/isup.retryPersonDeviceSync',
    method: 'post',
    data: { ...data, communityId: getCommunityId() }
  }).then(response => {
    const res = response.data
    if (res.code !== 0) throw new Error(res.msg || '重试失败')
    return res.data
  })
}

/** 全部失败项重试 */
export function retryPersonAllDevices(data) {
  return request({
    url: '/isup.retryPersonAllDevices',
    method: 'post',
    data: { ...data, communityId: getCommunityId() }
  }).then(response => {
    const res = response.data
    if (res.code !== 0) throw new Error(res.msg || '重试失败')
    return res.data
  })
}
